import { render } from "./IconYoutube.vue?vue&type=template&id=fc3101da&scoped=true"
import script from "./IconYoutube.vue?vue&type=script&lang=js"
export * from "./IconYoutube.vue?vue&type=script&lang=js"

import "./IconYoutube.vue?vue&type=style&index=0&id=fc3101da&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc3101da"]])

export default __exports__